import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';

import { ApiQuery } from '../../../../common/model/api.query';
import { ContactOutput } from '../model/contact.output';

export interface FetchKanbanContactsParams {
	readonly kanbanOrgModuleId: string;
	readonly ownerId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchKanbanContactsApiQuery extends ApiQuery<
	ContactOutput[],
	FetchKanbanContactsParams
> {
	client = 'iam';
	document = gql`
		query FetchKanbanContacts($ownerId: UUID!, $kanbanOrgModuleId: UUID!) {
			fetchKanbanContacts(
				ownerId: $ownerId
				kanbanOrgModuleId: $kanbanOrgModuleId
			) {
				...Contact
			}
		}
		${contact}
	`;
	method = 'fetchKanbanContacts';
}
